import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaUserCircle, FaEye, FaHistory, FaSignOutAlt } from "react-icons/fa";
import { FaSyringe, FaUserDoctor, FaHeartPulse } from "react-icons/fa6";
import { MdAddHomeWork, MdWorkHistory, MdKey } from "react-icons/md";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import './ComponentsStyles/sidebar.css';
import logo from '../Assets/logo.png';
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";

import { TbCoinRupeeFilled } from "react-icons/tb";
import { PiGraphBold } from "react-icons/pi";
import toast from "react-hot-toast";

export default function Sidebar({ collapsed, setCollapsed }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigator = useNavigate();

  const tabs = [
    { name: "My Profile", to: "/dashboard", icon: FaUserCircle },
    // { name: "My Health", to: "/dashboard/my-health", icon: FaHeartPulse },
    { name: "View Members", to: "/dashboard/members", icon: FaEye },
    // { name: "Book Home Collection", to: "/dashboard/book-homecollection", icon: FaSyringe },
     { name: "Book Home Collection", to: "/home-collection", icon: FaSyringe },
    { name: "Home Collection History", to: "/dashboard/collection-history", icon: MdAddHomeWork },
    // { name: "Book OPD Appointment", to: "/dashboard/book-opd", icon: FaUserDoctor },
     { name: "Book OPD Appointment", to: "/doctors-grid", icon: FaUserDoctor },
    { name: "OPD Appointment History", to: "/dashboard/opd-history", icon: MdWorkHistory },
    // { name: "Payment History", to: "/dashboard/payment-history", icon: TbCoinRupeeFilled },
    { name: "Past Report", to: "/dashboard/past-report", icon: FaHistory },
    { name: "Report Graph", to: "/dashboard/report-graph", icon: PiGraphBold },
    { name: "Change Password", to: "/dashboard/change-password", icon: MdKey },    
  ];



   const handleLogout = () => {
    // Clear user data (tokens, etc.)
    localStorage.clear();
    // sessionStorage.clear();

    // Optional: show message
    toast.success("You have been Sucessfully logged out.");

    // Redirect to login page
    navigator("/users/login", { replace: true });
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="mobile-toggle-btn"
        onClick={() => setMobileOpen(true)}

      >

        <div className="dotsection" >
          <PiDotsThreeOutlineVerticalFill size={24}/>
        </div>
        <img src={logo} alt="RB Diagnostic" className="mobile-logo" />
      </button>

      {/* Sidebar */}
      <div className={`dashboard-sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}>

        {/* Cross Button (Mobile only) */}
        <button
          className="sidebar-close-btn mobile-only"
          onClick={() => setMobileOpen(false)}
        >
          <X size={24} />
        </button>

        {/* Desktop Logo */}
        <div className="LogoDivSidebar desktop-only">
          <img
            src={logo}
            alt="RB Diagnostic"
            style={{ visibility: collapsed ? 'hidden' : 'visible', cursor: "pointer" }}
            onClick={() => {
              navigator('/');
              setMobileOpen(false);
            }}
          />
        </div>

        {/* Collapse Button for Desktop */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="sidebar-toggle-btn desktop-only"
        >
          {collapsed ? <ChevronRight color="black" /> : <ChevronLeft color="black" />}
        </button>

        {/* Sidebar Tabs */}
        <ul className="sidebar-main-nav">
          {tabs.map((tab, indx) => (
            <li className="sidebar-nav-item" key={indx}>
              <NavLink
                to={tab.to}
                end={tab.to === "/dashboard"}
                className={({ isActive }) =>
                  `sidebar-nav-link ${isActive ? "active" : ""}`
                }
                style={{ justifyContent: collapsed ? 'center' : 'start' }}
                onClick={() => setMobileOpen(false)}
              >
                <tab.icon className="sidebar-icon" />
                {!collapsed && <span>{tab.name}</span>}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Bottom Logout */}
        <ul className="sidebar-main-nav bottomOption">
          <li className="sidebar-nav-item">
            <span
              className="sidebar-nav-link"
              style={{ justifyContent: collapsed ? 'center' : 'start', cursor: 'pointer' }}
              onClick={() => {
                setMobileOpen(false);
                handleLogout();
              }}
            >
              <FaSignOutAlt className="sidebar-icon" size={20} />
              {!collapsed && <span>Log Out</span>}
            </span>
          </li>
        </ul>
      </div>

      {/* Overlay */}
      {mobileOpen && <div className="mobile-overlay" onClick={() => setMobileOpen(false)}></div>}
    </>
  );
}
